export default __webpack_public_path__ + "static/6-check-build-status-b4d2d11cc166da48c2ea7399d13965db.png";